import urlJoin from 'url-join';
import stipulate, {resolveUrl} from 'stipulate';

import {baseUrl, baseOptions} from './base';

export const cnameDnsZones = function(options = {}) {
  if (!options.hostname) {
    throw new Error('Expected options.hostname to be set');
  }

  let url = urlJoin(baseUrl, 'pb/cname-dns-zones/');
  const query = { hostname: options.hostname };
  url = resolveUrl(url, query);

  return stipulate(url, baseOptions);
};

export default {
  cnameDnsZones
};
